import React, { useState } from "react";

import { Lead } from "@/types";

import { appDate } from "@/utils/date";

import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import AppCard from "@/components/AppCard";
import AppDropdown from "@/components/AppDropdown";
import AppButton from "@/components/AppButton";

interface AppRemindMeProps {
  lead: Lead;
  onSubmit: (data: any) => void;
  onDelete: () => void;
}

const reminderDelayList = [
  { value: 60, label: "1 hour" },
  { value: 120, label: "2 hours" },
  { value: 180, label: "3 hours" },
  { value: 1440, label: "1 day" }, // 1440 minutes in a day
  { value: 2880, label: "2 days" }, // 2 days in minutes
  { value: 4320, label: "3 days" }, // 3 days in minutes
  { value: 10080, label: "1 week" }, // 1 week in minutes (7 * 1440)
];

const AppRemindMe: React.FC<AppRemindMeProps> = ({ lead, onSubmit, onDelete }) => {
  const [selectedDelay, setSelectedDelay] = useState<number>(0);

  const handleChangeReminderDelay = (newValue: string | number) => {
    const numericValue = typeof newValue === "string" ? parseInt(newValue, 10) : newValue;
    if (!isNaN(numericValue)) {
      setSelectedDelay(numericValue);
    } else {
      console.error("Invalid value:", newValue);
    }
  };

  const handleSubmit = () => {
    onSubmit(selectedDelay)
  }

  return (
    <AppBox>
      <AppCard className="mac-book:gap-4 gap-6">
        <AppText variant="h4">Send Me a Reminder About This Lead</AppText>
        {
          lead?.reminders && lead?.reminders.length
            ? <AppBox column center gap={4}>
                <AppText>Reminder is set for { appDate(lead.reminders[0].send_at) }</AppText>
                <AppButton onClick={onDelete}>Cancel</AppButton>
              </AppBox>
            : <AppBox center gap={4}>
                <AppButton disabled={!selectedDelay} onClick={handleSubmit}>Remind me</AppButton>
                <AppText>in</AppText>
                <AppDropdown
                  label={
                    reminderDelayList.find((item) => item.value === selectedDelay)?.label || "Delay"
                  }
                  items={reminderDelayList}
                  value={selectedDelay}
                  onChange={handleChangeReminderDelay}
                />
              </AppBox>
        }
        
      </AppCard>
    </AppBox>
  );
};

export default AppRemindMe;